import { render } from "./ConsolidateTaxAndFeeDialog.vue?vue&type=template&id=39706247"
import script from "./ConsolidateTaxAndFeeDialog.vue?vue&type=script&lang=js"
export * from "./ConsolidateTaxAndFeeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__